import { render, staticRenderFns } from "./Tenancy.vue?vue&type=template&id=1e2efd77&"
import script from "./Tenancy.vue?vue&type=script&lang=js&"
export * from "./Tenancy.vue?vue&type=script&lang=js&"
import style0 from "./Tenancy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Tenancy.vue"
export default component.exports